import { orderConfirmationPageContainerStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationPageContainer";
import { mediaQueriesBP } from "@waytek/Utilities/variables";
import { css } from "styled-components";

orderConfirmationPageContainerStyles.container = {
    ...orderConfirmationPageContainerStyles.container,

    gap: 0,
};

orderConfirmationPageContainerStyles.headerGridItem = {
    ...orderConfirmationPageContainerStyles.headerGridItem,

    css: css`
        ${orderConfirmationPageContainerStyles.headerGridItem?.css}

        &&& {
            margin-bottom: 25px;
        }

        ${mediaQueriesBP.minMD} {
            &&& {
                margin-top: 20px;
                margin-bottom: 37px;
            }
        }

        @media print {
            &&& {
                margin-bottom: 0;
            }
        }
    `,
};

orderConfirmationPageContainerStyles.orderInformationGridItem = {
    ...orderConfirmationPageContainerStyles.orderInformationGridItem,

    width: [12, 12, 12, 8, 8],
};

orderConfirmationPageContainerStyles.orderTotalGridItem = {
    ...orderConfirmationPageContainerStyles.orderTotalGridItem,

    width: [12, 12, 12, 4, 4],
    css: css`
        ${orderConfirmationPageContainerStyles.orderTotalGridItem?.css}

        &&& {
            margin-bottom: 39px;
        }

        ${mediaQueriesBP.minMDMaxLg} {
            &&& {
                margin-top: 30px;
            }
        }

        ${mediaQueriesBP.minLG} {
            &&& {
                padding-left: 40px;
                margin-bottom: 0;
            }
        }

        @media print {
            &&& {
                padding-left: 40px;
                margin-bottom: 0;
                margin-top: 89px;
            }
        }
    `,
};

orderConfirmationPageContainerStyles.productListGridItem = {
    ...orderConfirmationPageContainerStyles.productListGridItem,

    printWidth: 12,
    css: css`
        ${orderConfirmationPageContainerStyles.productListGridItem?.css}

        &&& {
            margin-top: 30px;
        }

        ${mediaQueriesBP.minMD} {
            &&& {
                margin-top: 40px;
            }
        }

        @media print {
            &&& {
                display: block;
            }
        }
    `,
};
